import './src/main.css'
import Decoration2 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration2.name, Decoration2)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration2/index.js